import React from 'react';
import BlockWrapper from './BlockWrapper';
import Container from '../interface/Container';
import PricingGrid from '../PricingGrid/PricingGrid';

const PricingGridBlock = ({ block }) => {
  return (
    <BlockWrapper>
      <Container>
        <PricingGrid mainTitle={block.mainTitle} cards={block.products} />
      </Container>
    </BlockWrapper>
  );
};

export default PricingGridBlock;
